import { render } from "./StatusIcon.vue?vue&type=template&id=b554d130&ts=true"
import script from "./StatusIcon.vue?vue&type=script&lang=ts"
export * from "./StatusIcon.vue?vue&type=script&lang=ts"

import "./StatusIcon.vue?vue&type=style&index=0&id=b554d130&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__